/**
 * Customer-app bottom navigation — visible only in the customer mobile build
 * (and during preview when ?mobile=1).
 *
 * Layout (5 slots, center is a +FAB for "New Booking"):
 *   Home · Bookings · [+ New Booking FAB] · Track · Account
 *
 * Active tab is derived from the URL pathname / hash / query string.
 */

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Package, Plus, Navigation, User } from "lucide-react";

const TABS_LEFT = [
  { id: "home",     label: "Home",     icon: Home,     to: "/customer/dashboard" },
  { id: "bookings", label: "Bookings", icon: Package,  to: "/customer/dashboard?filter=active" },
];
const TABS_RIGHT = [
  { id: "track",    label: "Track",    icon: Navigation, to: "/customer/dashboard?filter=active" },
  { id: "account",  label: "Account",  icon: User,       to: "/customer/dashboard#account" },
];

export default function CustomerBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const q = new URLSearchParams(location.search);
  const active =
    location.hash === "#account" ? "account" :
    q.get("filter") === "active" ? "bookings" :
    location.pathname === "/" ? "newbooking" :
    location.pathname.startsWith("/customer") ? "home" :
    "home";
  const tabClass = (id) => (active === id ? "is-active" : "");
  return (
    <nav className="t247-bottomnav" data-testid="customer-bottom-nav">
      <div className="t247-bottomnav-inner">
        {TABS_LEFT.map((t) => (
          <Link key={t.id} to={t.to} className={tabClass(t.id)} data-testid={`customer-nav-${t.id}`}>
            <t.icon size={22} strokeWidth={2} />
            <span>{t.label}</span>
          </Link>
        ))}
        <div className="t247-fab-wrap">
          <button
            type="button"
            className="t247-fab"
            onClick={() => navigate("/")}
            aria-label="New booking"
            data-testid="customer-nav-newbooking"
          >
            <Plus size={28} />
          </button>
          <span className="t247-fab-label">NEW</span>
        </div>
        {TABS_RIGHT.map((t) => (
          <Link key={t.id} to={t.to} className={tabClass(t.id)} data-testid={`customer-nav-${t.id}`}>
            <t.icon size={22} strokeWidth={2} />
            <span>{t.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
